import { Injectable } from '@angular/core';
import { DgError } from '@app/shared/models/dg-error';
import { NgxHttpClient } from '@app/shared/ngx-http-client';
import { TranslateService } from '@ngx-translate/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserSearchItem } from '@app/user/user-api.model';

export type PathwayFollower = {
  completionCount: number;
  completionPercent: number;
  enrollDate: string;
  orgRole:
    | 'Admin'
    | 'Career Professional'
    | 'Learning Professional'
    | 'Manager'
    | 'Member'
    | 'Technical Admin';
  totalPathwayItems: number;
  user: UserSearchItem[];
};

export type PathwayEnrolledInsights = {
  enrolledUsers: PathwayFollower[];
  enrollmentCount: number;
  hasMoreItems: boolean;
};

@Injectable({
  providedIn: 'root',
})
export class PathwayFollowersService {
  constructor(
    private translate: TranslateService,
    private http: NgxHttpClient
  ) {}

  public getFollowers(
    pathId: number,
    skip: number,
    take: number,
    sortColumn: string,
    sortAscending: boolean
  ) {
    return this.http
      .get<PathwayEnrolledInsights>('/pathways/getEnrolledInsights', {
        params: {
          pathwayId: pathId,
          skip: skip,
          take: take,
          sortColumn: sortColumn,
          sortAscending: sortAscending,
        },
      })
      .pipe(
        catchError((error: Error) => {
          return throwError(
            new DgError(
              this.translate.instant('Pathways_PathwayDetailAccessError'),
              error
            )
          );
        })
      );
  }
}
